// Central content config — swap text and image URLs here without touching layout.

export const brand = {
  name: "The Interior Desire",
  short: "Interior Desire",
  tagline: "Elevating Spaces. Engineering Comfort.",
  subTagline: "Award-winning interior design and architectural execution.",
  phoneDisplay: "+91 70035 22813",
  phoneRaw: "+917003522813", // for tel: and wa.me links
  email: "studio@theinteriordesire.com",
  city: "Kolkata, West Bengal",
  bookingCalendar: "#contact",
};

export const nav = [
  { label: "Work", href: "#portfolio" },
  { label: "Services", href: "#services" },
  { label: "Press", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const hero = {
  eyebrow: "Studio est. 2014",
  headline: "Elevating Spaces.\nEngineering Comfort.",
  subheadline:
    "Award-winning interior design and architectural execution — crafting residences and workplaces that feel inevitable, calm, and quietly luxurious.",
  ctaPrimary: "Book a Consultation",
  ctaSecondary: "View Portfolio",
  // Realistic Unsplash interior architecture image
  // Realistic Unsplash interior architecture image
  image: "/images/image2.jpg",
  imageAlt: "Modern interior design execution",
  stats: [
    { value: "120+", label: "Projects Delivered" },
    { value: "11", label: "Years of Craft" },
    { value: "9", label: "Design Awards" },
  ],
};

// Asymmetric masonry — each item declares its grid span.
// col / row spans are tuned for a 12-col grid with auto rows of ~90px.
export const portfolio = [
  {
    id: "p1",
    title: "Luxury Lounge Setup",
    label: "Living Space",
    location: "Kolkata",
    year: "2024",
    image: "/images/image3.jpg",
    span: "md:col-span-7 md:row-span-5 col-span-12 row-span-4",
  },
  {
    id: "p2",
    title: "Hexagon Tile Kitchen",
    label: "Modular Kitchen",
    location: "Kolkata",
    year: "2024",
    image: "/images/image1.jpg",
    span: "md:col-span-5 md:row-span-5 col-span-12 row-span-4",
  },
  {
    id: "p3",
    title: "Integrated Study",
    label: "Bedroom Interiors",
    location: "Kolkata",
    year: "2023",
    image: "/images/unnamed (13).webp",
    span: "md:col-span-4 md:row-span-4 col-span-12 row-span-4",
  },
  {
    id: "p4",
    title: "Organic Media Wall",
    label: "TV Unit Design",
    location: "Kolkata",
    year: "2024",
    image: "/images/unnamed (4).webp",
    span: "md:col-span-5 md:row-span-4 col-span-12 row-span-4",
  },
  {
    id: "p5",
    title: "Modern Foyer Partition",
    label: "Entrance Design",
    location: "Kolkata",
    year: "2023",
    image: "/images/unnamed (3).webp",
    span: "md:col-span-3 md:row-span-4 col-span-12 row-span-4",
  },
  {
    id: "p6",
    title: "Textured Dining Display",
    label: "Dining Space",
    location: "Kolkata",
    year: "2024",
    image: "/images/unnamed (6).webp",
    span: "md:col-span-12 md:row-span-4 col-span-12 row-span-4",
  },
];

export const services = [
  {
    id: "residential",
    icon: "Home",
    title: "Residential Interiors",
    description:
      "Considered homes shaped around the way you actually live — from first sketch to final styling.",
    bullets: ["Concept & Spatial Planning", "Material Library", "Bespoke Joinery"],
  },
  {
    id: "modular",
    icon: "Grid3X3",
    title: "Modular Kitchens",
    description:
      "Functional, food-first kitchens engineered with German hardware and stone finishes that age beautifully.",
    bullets: ["Custom Cabinetry", "Stone & Surface Selection", "10-year Warranty"],
  },
  {
    id: "commercial",
    icon: "Briefcase",
    title: "Commercial Spaces",
    description:
      "Offices, studios, and hospitality interiors that translate brand into atmosphere — and atmosphere into outcome.",
    bullets: ["Workspace Strategy", "Branded Environments", "Turnkey Execution"],
  },
];

export const testimonials = {
  ratingValue: 4.9,
  ratingMax: 5,
  ratingCount: 217,
  items: [
    {
      quote:
        "They listened first and drew second. Our home feels like it has always been ours — only quieter and far more beautiful.",
      author: "Anaïs & Rohan Mehta",
      role: "Sea-facing Apartment, Bandra",
    },
    {
      quote:
        "Every detail is considered, from the door pull to the way morning light hits the breakfast counter. Worth every rupee.",
      author: "Karthik R.",
      role: "Founder, Northbound Coffee Roasters",
    },
    {
      quote:
        "Delivered on the day they promised, on the budget they quoted. Rare in this industry. Their craft is rarer still.",
      author: "Priya Sundaram",
      role: "Managing Partner, Sundaram & Co.",
    },
  ],
};

export const footer = {
  studio: {
    name: "The Interior Desire",
    address: "1st Floor, 110/C, Amherst St, College Street Bata, College Row, Machuabazar, Kolkata, West Bengal 700009",
    hours: "Mon — Sat · 10:00 – 21:00 IST",
  },
  links: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "Pinterest", href: "https://pinterest.com" },
    { label: "Facebook", href: "https://www.facebook.com/theinteriordesire2023/" },
    ,
  ],
};
